import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import { userTypes } from "domain/GamesSearch/types";

const PlayersStack = ({
    players,
    players_count,
    max_players,
    stackSize,
    description,
    isPast,
}) => {
    if (players_count === 0) {
        return null;
    }

    const mainCastSize =
        max_players > players_count ? players_count : max_players;

    return (
        <div
            className={cn("flex aic ", {
                "mb-32": !description,
            })}
        >
            <ul className="players-stack">
                {players.slice(0, stackSize).map(({ avatar }, key) => {
                    return (
                        <li
                            key={`stack-item-${key}`}
                            className="players-stack__item"
                        >
                            {avatar && avatar.url && avatar.url.length > 0 && (
                                <img
                                    src={avatar.url}
                                    alt={`Игрок ${key}`}
                                    loading="lazy"
                                />
                            )}
                        </li>
                    );
                })}
            </ul>

            {mainCastSize > stackSize && !description && !isPast && (
                <div className="fs-body2 c-gs-medium-em">
                    {`+ ${mainCastSize - stackSize} играют`}
                </div>
            )}

            {description && (
                <div className="fs-body2 c-gs-medium-em">{description}</div>
            )}
        </div>
    );
};

PlayersStack.defaultProps = {
    stackSize: 4,
    players: [],
};

PlayersStack.propTypes = {
    players: PropTypes.arrayOf(userTypes),
    players_count: PropTypes.number,
    max_players: PropTypes.number,
    stackSize: PropTypes.number,
    description: PropTypes.string,
    isPast: PropTypes.bool,
};

export default PlayersStack;
